import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let CreateCreditCardModal = {
    selector: "vcCreateCreditCardModal",
    templateUrl:
        "/angular/components/profile/create-credit-card-modal.component.html",
    bindings: {
        user: "=",
        plan: "=",
        charge: "=",
    },
    controller: class CreateCreditCardModalController {
        // * bindings for typescript compiler *
        public user: any;
        public plan: any;
        public charge: any;
        // ************************************

        public errorMessage: string | boolean = false;

        private $scope: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
        }

        close(card: any): void {
            this.errorMessage = false;
            this.user.setCard(card).then(
                (response: object) => {
                    this.dialog.hide(response);
                    this.toast.success("Your payment method has been changed.");
                },
                (error: any) => {
                    this.errorMessage = error.message;
                    this.toast.error(error.message);
                }
            );
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("profile")
    .component(CreateCreditCardModal.selector, CreateCreditCardModal);
